import React, { Component, Fragment } from 'react';
import { Button, Card } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class StrategyDetails extends Component {
    render() {
        const position = this.props.position;
        if (!position) return null;

        let artDelta = null;
        if (position.rt_auto_sell_price) {
            const value =
                ((position.rt_auto_sell_price - position.avg_buy_price) / position.avg_buy_price) *
                100;
            artDelta = <span>{value.toFixed(2)}%</span>;
        }
        return (
            <Card
                title={`Strategy ${position.strategy_name}`}
                bordered={false}
                size={'small'}
                style={{ marginTop: 15 }}
            >
                <b style={{ fontSize: 16 }}>Buy Conditions</b>
                <br />
                {this.renderBuyStrat(position)}
                <br />
                <b style={{ fontSize: 16 }}>Sell Conditions</b>
                <br />
                {this.renderSellStrat(position)}
                {position.rt_auto_sell_price ? (
                    <Fragment>
                        <b>Apex Auto Sell (ART):</b> {position.rt_auto_sell_price.toFixed(8)}{' '}
                        {artDelta}
                        <br />
                    </Fragment>
                ) : null}
                <br />
                {this.renderStopLoss(position)}
            </Card>
        );
    }

    renderBuyStrat(record) {
        if (record.buy_strategy_config.type === 'trail') {
            return (
                <div>
                    <b>Type:</b> Trailing Buy
                    <br />
                    <b>Activated:</b> {record.buy_arm_armed ? 'Yes' : 'No'} <br />
                    <b>Activation Target:</b>{' '}
                    {record.buy_arm_target ? record.buy_arm_target.toFixed(8) : '-'} <br />
                    <b>Buy Trigger:</b>{' '}
                    {record.buy_arm_stop_loss ? record.buy_arm_stop_loss.toFixed(8) : '-'} <br />
                </div>
            );
        }
        return (
            <div>
                <b>Type:</b> Last Tick
                <br />
            </div>
        );
    }

    renderSellStrat(record) {
        if (record.sell_strategy_config.type === 'trail') {
            return (
                <div>
                    <b>Type:</b> Trailing Stop Loss
                    <br />
                    <b>Activated:</b> {record.arm_armed ? 'Yes' : 'No'} <br />
                    <b>Activation Target:</b>{' '}
                    {record.arm_target ? record.arm_target.toFixed(8) : '-'} <br />
                    <b>Sell Trigger:</b>{' '}
                    {record.arm_stop_loss ? record.arm_stop_loss.toFixed(8) : '-'} <br />
                </div>
            );
        }

        let result = (
            <span>{record.result_at_target ? `${record.result_at_target.toFixed(2)}%` : '-'}</span>
        );

        return (
            <div>
                <b>Type:</b>{' '}
                {record.sell_strategy_config.type === 'apex_percent_profit'
                    ? 'Dynamic Percent Profit'
                    : 'Percent Profit'}
                <br />
                <b>Target:</b> {record.target_price ? record.target_price.toFixed(8) : '-'} (
                {result})<br />
            </div>
        );
    }

    renderStopLoss(record) {
        if (record.stop_loss) {
            return (
                <div>
                    <b style={{ fontSize: 16 }}>Stop Loss</b>
                    <br />
                    <b>Target:</b> {record.stop_loss.toFixed(8)}
                    &nbsp;&nbsp;&nbsp;
                    <Button
                        onClick={() => {
                            this.props.store.botStore.actionStore.execute('set_stop_loss', {
                                position_id: record.id,
                                price: null
                            });
                        }}
                        type={'primary'}
                        disabled={
                            !record.active ||
                            record.status === 'BUY_ORDER_PLACED' ||
                            record.status === 'PLACING_BUY_ORDER'
                        }
                        shape="circle"
                        icon="close-circle"
                    />
                </div>
            );
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionView/StrategyDetails.js